export default "__VITE_ASSET__yOZHtCYa__"